/**
 * The company's number format (Settings > General > Number format), as a
 * locale such as "de-DE" or "en-US". Held here, not read from the store, so
 * plain formatting helpers can use it without importing the store; the store
 * keeps it in step (store.tsx), so a saved change applies on the next render.
 */
let current = "de-DE";

export const getNumberLocale = () => current;

export const setNumberLocale = (locale: string | null | undefined) => {
  current = locale || "de-DE";
};

/** The locale's thousands and decimal marks: "." and "," for German. */
export const numberSeparators = (locale = current) => {
  const parts = new Intl.NumberFormat(locale).formatToParts(12345.6);
  return {
    group: parts.find((part) => part.type === "group")?.value ?? ".",
    decimal: parts.find((part) => part.type === "decimal")?.value ?? ","};
};
